/***
 *
 *   MODAL
 *   Display an overlay modal anywhere in your application by calling
 *   context.modal.show() with an object containing the following props
 *
 *   PROPS
 *   title: (optional)
 *   text: message to the user (optional)
 *   form: a form object (optional: see form docs for more information)
 *   url: destination to send the form
 *   method: HTTP post type
 *   buttonText – text for the confirm button
 *
 **********/

import React, { useContext } from 'react';
import { ViewContext, Card, Form } from 'components/lib';
import { CSSTransition } from 'react-transition-group';
import './modal.scss';
import useWindowResize from 'components/hooks/getCurrentWindowWidth';

export function Modal(props) {
  const context = useContext(ViewContext);
  const deviceWidth = useWindowResize();

  return (
    <CSSTransition in appear timeout={0} classNames="modal">
      <div
        className="modal"
        onClick={(e) =>
          e.target === e.currentTarget && context.modal.hide(true)
        }
      >
        <div
          className="modal-content"
          style={{
            ...props.scroll && { overflowX: 'auto', maxHeight: '100%' },
            ...props.wide && { maxWidth: '50% !important', minHeight: 500 },
            ...props.maxWidth && { maxWidth: props.maxWidth, height: '100%', width: deviceWidth < 768 ? '100%' : '80%' }
          }}
        >
          <Card title={props.title} style={{ height: '100%' }}>
            {props.children && props.children}

            {props.text && <p>{props.text}</p>}

            {props.form && (
              <Form
                method={props.method}
                url={props.url}
                data={props.form}
                destructive={props.destructive}
                buttonText={props.buttonText}
                cancel={(e) => context.modal.hide(true)}
              />
            )}
          </Card>
        </div>
      </div>
    </CSSTransition>
  );
}
